import './contato.css';

import { GrLocation } from 'react-icons/gr';
import { BsInstagram, BsLinkedin, BsGithub } from 'react-icons/bs';
import { MdOutlineEmail } from 'react-icons/md';


export default function Contato() {


    const informacoes = [
        {
            local: 'Campinas / SP',
            url: '#',
            localIcone: <GrLocation />
        },

        {
            local: 'jlmsdev94@gmail.com',
            url: '#',
            localIcone: <MdOutlineEmail />
        },

        {
            local: 'Instagram',
            url: 'https://www.instagram.com/jlms.dev/',
            localIcone: <BsInstagram />
        },

        {
            local: 'Linkedin',
            url: 'https://www.linkedin.com/in/jlucasmelo/',
            localIcone: <BsLinkedin />
        },

        {
            local: 'Github',
            url: 'https://github.com/jlmsdev',
            localIcone: <BsGithub />
        }
    ];


    return(
        <section className='containerContato'>
            {informacoes.map( ( item ) => (
                <div key={item.local} className="componenteContato">

                    <span className='Icon'>{item.localIcone}</span>

                    <span className='infoContato'>

                        <a href= { item.url } target="blank">
                            {item.local}
                        </a>

                    </span>

                </div>
            ))}
        </section>
    );
}
